import { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { useNavigate, useParams, useSearch } from "@tanstack/react-router";
import { ErrorState, Skeleton } from "../../../components/States";
import { insightsApi, insightsKeys } from "../api";

/** Old bookmarks now land in the one issue queue, filtered to JS errors. */
export function LegacyErrorsRedirect() {
  const navigate = useNavigate();
  const search = useSearch({ strict: false }) as Record<string, unknown>;

  useEffect(() => {
    void navigate({
      to: "/issues",
      search: {
        kind: "js_error",
        q: typeof search.q === "string" ? search.q : undefined,
        release: typeof search.release === "string" ? search.release : undefined,
        status: typeof search.status === "string" ? search.status : undefined,
      } as never,
      replace: true,
    });
  }, [navigate, search.q, search.release, search.status]);

  return <Skeleton lines={6} />;
}

/** Resolve a legacy fingerprint URL to the issue that now owns its lifecycle. */
export function LegacyErrorDetailRedirect() {
  const { fingerprint } = useParams({ strict: false }) as { fingerprint: string };
  const navigate = useNavigate();
  const query = useQuery({
    queryKey: insightsKeys.error(fingerprint),
    queryFn: () => insightsApi.error(fingerprint),
  });

  useEffect(() => {
    if (query.data?.clusterId) {
      void navigate({ to: "/issues/$clusterId", params: { clusterId: query.data.clusterId }, replace: true });
    }
  }, [navigate, query.data?.clusterId]);

  if (query.isError) return <div className="card section"><ErrorState error={query.error} retry={() => void query.refetch()} /></div>;
  if (query.data && !query.data.clusterId) {
    return <div className="card section"><ErrorState error={new Error("This error has no matching issue")} /></div>;
  }
  return <Skeleton lines={8} />;
}
